<template>
  <div id="content" class="crpg-o-medical-concierge-common life life_4">
    <div id="detail" class="crpg-o-medical-concierge-common__detail life_4">
      <MoleculesCommonContentTitleBlue :title="content.title" />
      <div class="pic-1">
        <img :src="require('@/assets/img/mc_top.jpg')" alt="" class="pic-1__img" />
        <h2 class="newline imageText pic-1__text">{{ content.imageText }}</h2>
      </div>
      <div class="catch newline">{{ content.contentTitle }}</div>
      <div class="copy newline">{{ content.contentDetail }}</div>
      <MoleculesMedicalConcietgePrivilege :content="content.content" />
      <div class="spec">
        <div class="subtitle">{{ $t("medicalConcierge.subtitle") }}</div>
        <dl v-for="item in content.medicalService" :key="item.causelingTitle">
          <MoleculesMedicalConcietgeHealthCareService
            :medicalTitle="item.causelingTitle"
            :contentText="item.causelingContent"
            :ReceptionTimeText="item.causelingTime"
            :addressText="item.causelingAdress"
            :priceText="item.causelingPrice"
            :area="item.causelingArea"
          ></MoleculesMedicalConcietgeHealthCareService>
        </dl>
      </div>
      <div class="pic_2">
        <img :src="contentMentalHealthImage" alt="" />
      </div>
      <div class="spec">
        <dl v-for="item in content.causelingService" :key="item.causelingTitle">
          <MoleculesMedicalConcietgeHealthCareService
            :medicalTitle="item.causelingTitle"
            :contentText="item.causelingContent"
            :ReceptionTimeText="item.causelingTime"
            :addressText="item.causelingAdress"
            :priceText="item.causelingPrice"
            :area="item.causelingArea"
          ></MoleculesMedicalConcietgeHealthCareService>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import MoleculesMedicalConcietgeHealthCareService from "@/components/molecules/medicalConcierge/HealthCareService.vue";
import MoleculesMedicalConcietgePrivilege from "@/components/molecules/medicalConcierge/Privilege.vue";
import MoleculesCommonContentTitleBlue from "@/components/molecules/common/ContentTitleBlue.vue";

import text from "@/assets/txt/medical_concierge.json";

var textDate = text;

export default {
  name: "PgMedicalConcierge",
  components: {
    MoleculesMedicalConcietgeHealthCareService,
    MoleculesMedicalConcietgePrivilege,
    MoleculesCommonContentTitleBlue,
  },
  data() {
    return {
      content: textDate,
      contentTopImage: require("@/assets/img/mc_top.jpg"),
      contentMentalHealthImage: require("@/assets/img/mental_health.jpg"),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/organisms/medicalConcierge/medicalConciergeContent.scss";
</style>
